import * as AccordionPrimitive from '@radix-ui/react-accordion';

export const Accordion = AccordionPrimitive.Root;
